import { useTranslation } from 'react-i18next';
import SecSeperator from './ui/SecSeperator';
import { COUNTRY_TOP_LEVEL_DOMAIN } from '../constants';
import { getTopLevelDomain } from '../utils/translation';

const pressArray = [
    {
        image: '/svgs/presse-techcabal.svg',
        link: 'https://techcabal.com/2022/09/16/stellantis-and-africar-partner-to-launch-auto24-a-used-car-marketplace/',
        alt: "techcabal",
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,
        // Just to view data:
        COUNTRY_TOP_LEVEL_DOMAIN.bj, COUNTRY_TOP_LEVEL_DOMAIN.coke, COUNTRY_TOP_LEVEL_DOMAIN.tg, COUNTRY_TOP_LEVEL_DOMAIN.tz, COUNTRY_TOP_LEVEL_DOMAIN.ug
        ]
    },
    {
        image: '/images/logo-topauto.webp',
        alt: "topauto",
        link: 'https://topauto.co.za/news/87664/new-used-car-marketplace-launched-in-south-africa/',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.coza]
    },
    {
        image: '/svgs/press-logo-techinafrica.svg',
        alt: "techinafrica",
        link: 'https://www.techinafrica.com/auto24-expands-its-pre-owned-car-marketplace-to-4-thriving-african-markets/',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.coza, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,]
    },
    {
        image: '/images/logo-technext.webp',
        alt: "technext",
        link: 'https://technext24.com/2023/09/28/auto24-expands-used-cars-marketplace/',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.coza]
    },
    {
        image: '/images/logo-iol.webp',
        alt: "iol",
        link: 'https://www.iol.co.za/business-report/companies/stellantis-auto24-platform-to-take-on-sas-booming-online-used-car-market-d33cc828-227b-4668-8e26-4b231abd2d91',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.coza]
    },
    {
        image: '/svgs/presse-lebrief.svg',
        alt: "lebrief",
        link: 'https://www.lebrief.ma/stellantis-investit-dans-africar-group-pour-creer-auto24/',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,]
    },
    {
        image: '/svgs/presse-lejournaldelautomobile.svg',
        alt: "lejournaldelautomobile",
        link: 'https://journalauto.com/constructeurs/stellantis-entre-au-capital-dafricar-pour-creer-auto24/',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,]
    },
    {
        image: '/svgs/presse-largus.svg',
        alt: "largus",
        link: 'https://www.largus.fr/pros/actualite-automobile/stellantis-se-lance-dans-la-vente-de-voitures-doccasion-en-afrique-11030393.html',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,]
    },
    {
        image: '/images/logo-itweb.webp',
        alt: "itweb",
        link: 'https://itweb.africa/content/G98YdMLGzrL7X2PD',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.coza]
    },
    {
        image: '/images/logo-press-forbes.webp',
        alt: "forbes",
        link: '',
        includeInDomain: [COUNTRY_TOP_LEVEL_DOMAIN.asterdio, COUNTRY_TOP_LEVEL_DOMAIN.ci, COUNTRY_TOP_LEVEL_DOMAIN.coza, COUNTRY_TOP_LEVEL_DOMAIN.ma, COUNTRY_TOP_LEVEL_DOMAIN.rw, COUNTRY_TOP_LEVEL_DOMAIN.sn, COUNTRY_TOP_LEVEL_DOMAIN.tg,]
    }
];

function pressArrayFilteredByDomain () {
    const topLevelDomain = getTopLevelDomain();
    return pressArray.filter(press => press.includeInDomain.includes(topLevelDomain));
}

const Press = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="press">
            <div className="padding">
                <SecSeperator className="center" />
                <h2 className="title" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t('theySpeakAboutUs')}</h2>
                <p className="subtitle" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t('theySpeakAboutUsSubTitle')}</p>
                <div className="image-wrapper top">
                    {pressArrayFilteredByDomain().slice(0, 3).map((item, index) => {
                        return (
                            <div className="image-container" key={index}>
                                <a href={item?.link ?? ''} target='_blank' rel="noreferrer">
                                    <img src={item.image} alt={item.alt} loading='lazy' />
                                </a>
                            </div>
                        );
                    })}
                </div>
                <div className="image-wrapper bottom">
                    {pressArrayFilteredByDomain().slice(3).map((item, index) => {
                        return (
                            <div className="image-container" key={index}>
                                <a href={item?.link ?? ''} target='_blank' rel="noreferrer">
                                    <img src={item.image} alt={item.alt} loading='lazy' />
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Press;
